// TelcoTrack — Workflow: sdílené typy
// Oddělené, aby se daly importovat bez cyklů mezi konstantami a helpery.

// =============================================================================
// WORKFLOW PHASE INTERFACES
// =============================================================================

/** Definice fáze ve workflow (name se doplňuje z PHASE_NAMES při vrácení) */
export interface WorkflowPhaseDef {
  code: string;
  color: string;
  nextPhases: string[];
  previousPhases: string[];
  isFinal: boolean;
  isInitial: boolean;
}

/** Fáze vrácená z getPhaseByCode / getNextPhases / getPreviousPhases – name je vždy vyplněné z PHASE_NAMES */
export interface WorkflowPhase extends WorkflowPhaseDef {
  name: string;
  /** Jen u typu BUDOVA: větev workflow (7 = BUDOVA.1 Zrušený, 8 = BUDOVA.2, 9 = BUDOVA.3). */
  transitionBudovaWorkflowId?: 7 | 8 | 9;
}

export interface ObjectTypeWorkflow {
  objectType: string;
  phases: WorkflowPhaseDef[];
  lineStyle: 'solid' | 'dashed';
  lineWeight: 'thin' | 'thick';
}

/** BUDOVA větev (7/8/9) — legacy metadata / API query; navigace jde z kódu fáze. */
export type WorkflowVariantContext = {
  budovaWorkflowId?: 7 | 8 | 9;
};
